import "./Login.css";
import React, { useEffect, useState } from 'react'
import { Error } from '@/_service/notification/notification';
import { useNavigate } from "react-router-dom";
import { useAuthContext, useLanguageContext, useLoginToggle } from '@/hooks';
import { Button, PasswordInput } from '@/_component/Common';
import * as Yup from 'yup';
import { useCallback } from "react";
import { timeout } from "@/utility";
import { DEFAULT_COUNTRY_CODE, DEFAULT_COUNTRY_CODE_WITH_PLUS } from "@/_constant";
import { fetchCountries } from "@/apis";

export default function Login({ handleChangeRegistrationspage, show }) {
  const { language } = useLanguageContext();
  const { login, forgotPassword }  = useAuthContext();
  const handleLoginToggle = useLoginToggle();
  const navigate = useNavigate();

  const countryCode = DEFAULT_COUNTRY_CODE;
  const [countryList, setCountryList] = useState([]);
  const [loginFormData, setLoginFormData] = useState({
    username: '',
    password: '',
  });
  const [errors, setErrors] = useState({});
  const loginSchema = Yup.object().shape({
    username: Yup.string()
      .matches(/^[0-9]+$/, "Mobile number must be digits only")
      .min(10, "Mobile number must be at least 10 digits")
      .max(10, "Mobile number must not exceed 10 digits")
      .required("Mobile number is required"),
    password: Yup.string().required("Password is required")
  });

  const fetchCountriesList = useCallback(async () => {
    try {
      const countryCodes = await fetchCountries();
      setCountryList(countryCodes);
    } catch (error) {
      console.error('Error - ', error);
    }
  }, [setCountryList]);

  useEffect(() => {
    fetchCountriesList();
  }, [fetchCountriesList]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setLoginFormData({ ...loginFormData, [name]: value });
  };

  const validateLoginForm = () => {
    try {
      return loginSchema.validateSync(loginFormData, { abortEarly: false });
    } catch (err) {
      const validationErrors = {};
      err.inner.forEach((error) => {
        validationErrors[error.path] = error.message;
      });
      setErrors(validationErrors);
      timeout(() => setErrors({}), 4000);
    }
  }

  const signUserIn = async (event) => {
    event.preventDefault();
    if (!validateLoginForm()) return;
    const username = `${DEFAULT_COUNTRY_CODE_WITH_PLUS}${loginFormData.username}`;
    await login(username, loginFormData.password);
  }

  const forgetPassword = (e) => {
    const username = loginFormData.username;
    if (!username || username === "") {
      return Error('Please enter a username');
    } else if(username.length < 10){
      return Error("Please enter valid mobile no")
    }
    forgotPassword(`${DEFAULT_COUNTRY_CODE_WITH_PLUS}${username}`)
    .then(_ => redirectToChangePassword())
  }

  const redirectToChangePassword = () => {
      const item = {
        username: loginFormData.username,
        route: 'password',
        phoneNumber: `${DEFAULT_COUNTRY_CODE_WITH_PLUS}${loginFormData.username}`,
      }
      handleLoginToggle(false);
      navigate("/resetpassword", { replace: true, state: JSON.stringify(item) })
  }

  return (
    <div className={`modal fade login-popup ${show}`} data-bs-backdrop="static" data-bs-keyboard="false" id="login_popup" style={{ "display": "block", backgroundColor: "rgba(0, 0, 0, 0.568)"  }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content rounded-5">
          <div className='text-end'>
            <Button noSpacing
              className="btn-close fs-6 me-3 mt-3"
              aria-label="Close" onClick={() => handleLoginToggle(false)}></Button>
          </div>
          <div className="modal-body p-0">
            <div className="login-popup-main">
              <div className="login-inner px-5">
                <h3 className="text-center">LOGIN</h3>
                <form onSubmit={signUserIn}>
                  <div className="input-group">
                    <select value={countryCode} name="countryCode" id="countryCodeId_login" className="form-select rounded-start-4" disabled
                      style={{ maxWidth: "5rem" }}>
                      {countryList.map((option, index) => (
                        <option key={index} value={option.value}>
                          {option?.display?.replace(/&nbsp;/g, ' ')}
                        </option>
                      ))}
                    </select>
                    <input minLength="10" maxLength="10" type="text" name="username" className="form-control rounded-end-4" value={loginFormData.username} onChange={handleInputChange} placeholder={language("label.enter_phone_number")} />
                  </div>
                  {errors.username && <div><small className='text-danger'>{errors.username}</small></div>}
                  <div className="mt-3">
                    <PasswordInput
                      name="password"
                      placeholder={language("label.enter_you_login_password")}
                      value={loginFormData.password}
                      onChange={handleInputChange}
                    />
                  </div>
                  {errors.password && <div><small className='text-danger'>{errors.password}</small></div>}
                  <button
                    id="loginbuttonid"
                    type="submit"
                    className="mt-5"
                  >
                    {language("label.login")}
                  </button>
                </form>
                <div
                  className="text-right forgot_pass"
                  data-bs-dismiss="modal"
                >
                  <span className="link" onClick={(e) => forgetPassword(e)}>{language("label.forgot_password")}?</span>
                </div>
              </div>
              <div className="login-bottom">
                <p lang="en">
                  {language("If_you_are_not_a_member")}
                </p>
                <div className="text-center">
                  <button
                    data-bs-dismiss="modal"
                    className="register_modal_btn"
                    onClick={(e) => { handleChangeRegistrationspage(e); }}
                  >
                    {language("label.register")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

